module KendoWidgets
{
	export class CalendarOptions implements kendo.ui.CalendarOptions
	{
		dates?: any;
		depth?: string;
		footer?: boolean | string | Function;
		format?: string;
		max?: Date;
		min?: Date;
		month?: kendo.ui.CalendarMonth;
		weekNumber?: boolean;
		start?: string;
		value?: Date;

		change?(e: kendo.ui.CalendarEvent): void;
		navigate?(e: kendo.ui.CalendarEvent): void;
	}

	export class Calendar extends kendo.ui.Calendar implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Calendar; }

		constructor(element: Element, options?: KendoWidgets.CalendarOptions)
		{
			if (options == null)
				options = new KendoWidgets.CalendarOptions();


			super(element, options);
		}

		closeWindow()
		{
			$("#" + this.element.attr("id") + "_Window").data("kendoWindow").close();
		}

		clear()
		{
			this.value("");
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion
	}

	Calendar.fn = Calendar.prototype;
	Calendar.fn.options = $.extend(true, {}, kendo.ui.Calendar.fn.options);
	Calendar.fn.options.name = "Calendar";
	kendo.ui.plugin(Calendar);
}

interface JQuery
{
	kendoCalendar(options?: KendoWidgets.CalendarOptions): JQuery;
}